module.exports = require("webpack-bundle-analyzer");